<template>
    <el-dialog
        title="Créer un client"
        width="80%"
        :visible.sync="show"
        :append-to-body="true"
        @close="reset"
    >
        <el-form
            :model="form"
            :rules="rules"
            label-width="200px"
            ref="form"
        >
            <el-form-item label="Nom" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="Adresse de livraison" prop="delivery_address">
                <el-input v-model="form.delivery_address"></el-input>
            </el-form-item>
            <el-form-item label="Adresse de facturation" prop="billing_address">
                <el-input v-model="form.billing_address"></el-input>
            </el-form-item>
            <el-form-item label="SIRET" prop="siret">
                <el-input v-model="form.siret"></el-input>
            </el-form-item>
            <el-form-item label="N° TVA intra communautaire" prop="tva_number">
                <el-input v-model="form.tva_number"></el-input>
            </el-form-item>
            <el-form-item label="Correspondant EDF" prop="contact_edf">
                <el-input v-model="form.contact_edf"></el-input>
            </el-form-item>
            <el-form-item label="N° de téléphone correspondant EDF" prop="contact_edf_phone">
                <el-input v-model="form.contact_edf_phone"></el-input>
            </el-form-item>
            <el-form-item label="Contact client" prop="contact_client">
                <el-input v-model="form.contact_client"></el-input>
            </el-form-item>
            <el-form-item label="Téléphone" prop="contact_client_phone">
                <el-input v-model="form.contact_client_phone"></el-input>
            </el-form-item>
            <el-form-item label="Sites" prop="related_factories_uid">
                <el-transfer
                    v-model="form.related_factories_uid"
                    :data="availableFactories"
                    :titles="['Sites non rattachés', 'Sites rattachés']"
                    class="site-transfert"
                ></el-transfer>
            </el-form-item>
        </el-form>

        <span slot="footer">
            <el-button @click="show = false">Annuler</el-button>
            <el-button :loading="loading" type="primary" @click="create">
                {{ isEdit ? 'Modifier' : 'Créer'}}
            </el-button>
        </span>
    </el-dialog>
</template>

<script>

import {mapGetters} from 'vuex';

export default {
    data (){
        return {
            show: false,
            loading: false,
            isEdit: false,
            form: {
                name: '',
                delivery_address: '',
                billing_address: '',
                siret: '',
                tva_number: '',
                contact_edf: '',
                contact_edf_phone: '',
                contact_client: '',
                contact_client_phone: '',
                related_factories_uid: [],
            },
            rules: {
                name: [{required: true, message: 'Ce champ ne peut pas être vide'}],
                delivery_address: [{required: true, message: 'Ce champ ne peut pas être vide'}],
                billing_address: [{required: true, message: 'Ce champ ne peut pas être vide'}],
                siret: [{required: true, message: 'Ce champ ne peut pas être vide'}],
                tva_number: [{required: true, message: 'Ce champ ne peut pas être vide'}],
                contact_edf: [{required: true, message: 'Ce champ ne peut pas être vide'}],
                contact_client: [{required: true, message: 'Ce champ ne peut pas être vide'}],
                related_factories_uid: [{required: true, message: 'Ce champ ne peut pas être vide'}],
            }
        };
    },

    computed: {
        ...mapGetters([
            'factories'
        ]),
        availableFactories() {
            return this.factories.map(factory => {
                return {
                    key: factory.uid,
                    label: factory.name
                };
            });
        }
    },
    methods: {
        open (client=null){
            this.show = true;
            if(client){
                this.isEdit = true;
                this.$set(this, 'form', JSON.parse(JSON.stringify(client)));
            }
        },
        create (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.loading = true;
                    let action = this.isEdit ? 'patchItem' : 'createItem';
                    let notification = {
                        error: {
                            title: this.isEdit ? 'Erreur modification client' :'Erreur création client',
                            message: this.isEdit ? `Le client ${this.form.name} n'a pas pu être modifié` :`Le client ${this.form.name} n'a pas pu être créé`,
                        },
                        success: {
                            title: this.isEdit ? 'Client modifié' :'Client créé',
                            message: this.isEdit ? `Le client ${this.form.name} a bien été modifié` :`Le client ${this.form.name} a bien été créé`,
                        },
                    };
                    this.$store.dispatch(action, {
                        item: this.form,
                        url: this.$store.state.api.meta.listModels.clients.url,
                        model: 'clients',
                    }).then(() => {
                        this.$notify.success(notification.success);
                        this.$emit('reload');
                        this.show = false;
                    }).catch(() => {
                        this.$notify.error(notification.error);
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            });
        },
        reset (){
            this.isEdit = false;
            this.$set(this, 'form', {
                name: '',
                delivery_address: '',
                billing_address: '',
                siret: '',
                tva_number: '',
                contact_edf: '',
                contact_edf_phone: '',
                contact_client: '',
                contact_client_phone: '',
            });
        }
    },
};
</script>

<style lang="scss">
.site-transfert {
    display: flex;
    flex-direction: column;
    align-items: center;
    @media(min-width: 1143px) {
        flex-direction: row;
    }
    .el-button {
        margin-top: 10px !important;
        @media(min-width: 1143px) {
            margin-top: 0 !important;
        }
        i {
            transform: rotate(90deg) !important;
            @media(min-width: 1143px) {
                transform: unset !important;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Client/modal-create.vue